import { ConfigFieldDecorator } from '@/eventConfig/types.ts';
import { FieldType } from '@/form/FormProvider.tsx';
import { TextUtils } from '@/util/textUtils.ts';
import { isNil } from 'ramda';

export const decorate = (decorator: ConfigFieldDecorator, value: FieldType) => {
  if (isNil(value)) {
    return value;
  }

  const stringValue = `${value}`;
  switch (decorator.type) {
    case 'numeric':
      return TextUtils.numeric(stringValue);
    case 'ucwords':
      return TextUtils.ucWords(stringValue);
    case 'date':
      if (!decorator) {
        return value;
      }
      return TextUtils.formatDate(stringValue, decorator!.format, decorator!.delimiter, decorator!.re);
    case 'lowerAndTrim':
      return TextUtils.lowerAndTrim(stringValue);
    case 'upper':
      return TextUtils.upper(stringValue);
    case 'clean':
      return TextUtils.clean(stringValue);
    case 'ucfirst':
      return TextUtils.ucFirst(stringValue);
    case 'delimit': {
      if (!decorator.format || !decorator.delimiter) {
        return value;
      }
      // Look, here its an array of string or number...
      const format = decorator.format as (string | number)[];
      return TextUtils.delimit(stringValue, format, decorator.delimiter);
    }
    case 'ftin':
      return TextUtils.formatFeetInches(stringValue);

    default:
      console.log(`Error: Decorator of type ${decorator.type} not supported`);
      return value;
  }
};
